import React from 'react'
import Img from 'gatsby-image'

import BusinessSection from '@/business-section'
import Testimonial from '@/testimonial'
import BrandLogos from '@/brand-logos'

import './styles.css'

const SectionBeautyPageants = ({ gray, data }) => {
  return (
    <BusinessSection
      title="+200 beauty pageants use Choicely"
      subtitle="for casting, voting, judge rating & more"
      gray={gray}
    >
      <BrandLogos />

      <div className="flex justify-center mw788 center mb5">
        <ImageGroupItem src={data.pageants1.sizes} />
        <ImageGroupItem src={data.pageants3.sizes} />
        <ImageGroupItem src={data.pageants4.sizes} />
        <ImageGroupItem src={data.pageants2.sizes} />
      </div>

      <div className="mw788 center">
        <Testimonial
          avatarSrc={data.avatar1.sizes}
          name="Sunneva Kantola"
          status={
            <span>Country Manager <br /> Miss Universe Finland</span>
          }
          comment={
            <span>
              “Our organisation has worked with Next Miss team for the past 3 years.
              <strong className="fw5">Results have been amazing.</strong> I can truly recommend Next Miss to any
              beauty pageant organisation.”
            </span>
          }
        />
        <Testimonial
          avatarSrc={data.avatar2.sizes}
          name="Gareth Flusk"
          status={
            <span>Group Content <br /> Miss Universe South Africa</span>
          }
          comment={
            <span>
              “We run the casting and voting in 2019 using Next Miss toolkit. <strong className="fw5">We received a record amount of applications and we are super happy with the service.</strong> Thank you Next Miss team.”
            </span>
          }
        />
        <Testimonial
          avatarSrc={data.avatar3.sizes}
          name="Julia Titova"
          status={
            <span>CEO & Founder <br /> Miss USSR UK</span>
          }
          comment={
            <span>
              “We have been using Next Miss for 3 years and made excellent results with engagement and new revenue. <strong className="fw5">The platform is very easy to use</strong> and I highly recommend it for others.”
            </span>
          }
        />
        <Testimonial
          avatarSrc={data.avatar4.sizes}
          name="Gohar Harutyunyan"
          status={
            <span>Country Manager <br /> Miss Universe Armenia</span>
          }
          comment={
            <span>
              “Miss Universe Armenia used Next Miss tools to run our people’s choice voting in 2019. For us it was very easy to work with Next Miss team and the <strong className="fw5">voting generated excellent traction.</strong>”
            </span>
          }
        />
      </div>
    </BusinessSection>
  )
}

function ImageGroupItem({ src }) {
  return (
    <div className="w-25">
      <Img sizes={src} alt="" />
    </div>
  )
}

export default SectionBeautyPageants



// WEBPACK FOOTER //
// ./src/components/section-beauty-pageants/section-beauty-pageants.js